<div class="flex f-fd--column">
  <div>
    <howden-page-title></howden-page-title>
  </div>
  <form [formGroup]="model.filterForm">
    <div class="flex f-gap--10px">
      <mat-form-field class="f-basis--3">
        <mat-label i18n="@@app.sane-projects.search.client">Cliente</mat-label>
        <input matInput [formControlName]="model.C_CLIENT_DESC" />
      </mat-form-field>
      <mat-form-field class="f-basis--1">
        <mat-label i18n="@@app.sane-projects.search.projectDateFrom">Fecha Desde</mat-label>
        <input matInput [matDatepicker]="projectDateFromPicker" [formControlName]="model.C_PROJECT_DATE_FROM"
          [howdenControlError]="projectDateFromError" />
        <mat-error #projectDateFromError></mat-error>
        <mat-datepicker-toggle matSuffix [for]="projectDateFromPicker"></mat-datepicker-toggle>
        <mat-datepicker #projectDateFromPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="f-basis--1">
        <mat-label i18n="@@app.sane-projects.search.projectDateTo">Fecha Hasta</mat-label>
        <input matInput [matDatepicker]="projectDateToPicker" [formControlName]="model.C_PROJECT_DATE_TO"
          [howdenControlError]="projectDateToError" />
        <mat-error #projectDateToError></mat-error>
        <mat-datepicker-toggle matSuffix [for]="projectDateToPicker"></mat-datepicker-toggle>
        <mat-datepicker #projectDateToPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="f-basis--3">
        <mat-label i18n="@@app.sane-projects.search.projectName">Nombre del Programa</mat-label>
        <input matInput [formControlName]="model.C_PROJECT_NAME" />
      </mat-form-field>
      <mat-form-field class="f-basis--2">
        <mat-label i18n="@@app.sane-projects.search.office">Oficina</mat-label>
        <input matInput [formControlName]="model.C_OFFICE_DESC" />
      </mat-form-field>
      <mat-form-field class="f-basis--2">
        <mat-label i18n="@@app.sane-projects.search.user">Usuario</mat-label>
        <input matInput [formControlName]="model.C_USER_DESC" />
      </mat-form-field>
    </div>
  </form>
  <div>
    <howden-table
      class="small-font"
      keyField="projectId"
      paginable="server"
      sortable="server"
      filterable="server"
      tableFixedHeight="60vh"
      [clickableRow]="true"
      [cols]="model.columns"
      [data]="model.data"
      [currentPage]="model.request.pageNumber"
      [pageSize]="model.request.pageSize"
      [totalRows]="model.length"
      [buttons]="model.buttons"
      (rowClicked)="onRowClicked($event)"
      (buttonClicked)="onAction($event)"
      (pageChanged)="onServerSideConfigChanged($event)"
      (sortChanged)="onServerSideConfigChanged($event)"
      (filtersChanged)="onServerSideConfigChanged($event)"
    >
    </howden-table>
  </div>
</div>
